import React, { Component } from 'react';
import { Example } from 'examples';
import Button from '../Button/Button';
import Group from '../Group/Group';
import Modal from '../Modal/Modal';
import Progressbar from '../Progressbar/Progressbar';
import TransitionGroup from '../TransitionGroup/TransitionGroup';

export default class ModalExample extends Component {

  state = {};

  onClick = e => {
    const type = e.target.dataset.type;

    window.showAppInfo(type);
    this.setState({ type });
  };

  onClose = e => this.setState({ type: undefined});

  render() {
    const { type } = this.state;

    return (
      <Example {...this.props} className="no-props">
        <Group>
          <Button onClick={this.onClick} data-type="button">Instant modal</Button>
          <Button onClick={this.onClick} data-type="animated">Animated modal</Button>
          <Button onClick={this.onClick} data-type="spinner">Overlay with a spinner</Button>
        </Group>
        {type === 'button' && (
          <Modal onClose={this.onClose} className="centered button">
            <p>
              Clicking on the text will not close the dialog.<br/>
              The button below has a custom onClick handler.<br/>
              Hitting Esc will also close the dialog.
            </p>
            <Button className="primary" onClick={this.onClose}>Close me</Button>
          </Modal>
        )}
        <TransitionGroup in={type === 'animated'} className="animate-lightbox">
          <Modal onClose={this.onClose} className="centered button">
            <p>
              This is an animated modal.
            </p>
            <Button className="primary" onClick={this.onClose}>Close me</Button>
          </Modal>
        </TransitionGroup>
        {type === 'spinner' && (
          <Modal onClose={this.onClose} className="centered light-overlay">
            <Progressbar circular indeterminate/>
          </Modal>
        )}
      </Example>
    );
  }

}
